import isMobile   from 'ismobilejs';
import windowSize from 'get-window-size';
import browser    from 'browser-detect';

const userAgent = {
	state: {
		window: {
			width: windowSize().width,
			height: windowSize().height
		},
		device: {
			isPhone: isMobile.phone,
			isTablet: isMobile.tablet || (('ontouchstart' in window) && window.innerWidth >= 768 && window.innerheight >= 768),
			isMobile: isMobile.any || ('ontouchstart' in window)
		},
		orientation: null,
		browser: {
			name: browser().name,
			version: browser().version
		},
		screentest: false,
		isScrollLock: false
	},
	mutations: {
		DETECT_DEVICE(state, devices) {
			state.device = devices;
		},
		DETECT_ORIENTATION(state, payload) {
			if (payload) {
				state.orientation = 'landscape';
			} else {
				state.orientation = 'portrait';
			}
		},
		UPDATE_WINDOW_PARAMS(state, payload) {
			state.window = payload;
			state.device.isMobile = payload.width < 1024;
		},
		UPDATE_SCREENTEST: (state, payload) => {
			state.screentest = payload;
		}
	}
};

export default userAgent;
